<ng-container [formGroup]="form">

  <div class="row cl-spacing-small">
    <div class="col-4">
      <label class="form-label" for="encrypt">Encryption</label>
      <select class="form-select" formControlName="encrypt" id="encrypt">
        <option [ngValue]="false">Plain</option>
        <option [ngValue]="true">Encrypt</option>
      </select>
    </div>
  </div>

  <!-- DRMtoday Onboard Section - Only shown when encryption is enabled -->
  <div [style.display]="form.get('encrypt').value ? 'block' : 'none'">
    <div class="row cl-spacing-small mt-4">
      <div class="col-12">
        <h5>DRMtoday Onboard</h5>
      </div>
    </div>
    <div class="row cl-spacing-small">
      <div class="col-4">
        <label class="form-label" for="onboard">Enable DRMtoday Onboard</label>
        <select class="form-select" formControlName="onboard" id="onboard">
          <option [ngValue]="false">Disabled</option>
          <option [ngValue]="true">Enabled</option>
        </select>
      </div>
      <div [style.display]="form.get('onboard').value ? 'block' : 'none'" class="col-8">
        <label class="form-label" for="onboard_tags">Onboard Tags</label>
        <input
          class="form-control"
          formControlName="onboard_tags"
          id="onboard_tags"
          placeholder="Enter tags separated by commas (e.g., tag1, tag2, tag3)"
          type="text"
        />
        <p class="valid-feedback">Comma-separated, e.g. tag1, tag2.</p>
      </div>
    </div>
    <div class="row cl-spacing-small">
      <div [style.display]="form.get('onboard').value ? 'block' : 'none'" class="col-6">
        <label class="form-label" for="onboard_window_start">Onboard Window Start</label>
        <input
          class="form-control"
          formControlName="onboard_window_start"
          id="onboard_window_start"
          placeholder="2026-01-01T00:00Z"
          type="datetime-local"
        />
        <p class="valid-feedback">In your local time; sent as UTC.</p>
      </div>
      <div [style.display]="form.get('onboard').value ? 'block' : 'none'" class="col-6">
        <label class="form-label" for="onboard_window_end">Onboard Window End</label>
        <input
          class="form-control"
          formControlName="onboard_window_end"
          id="onboard_window_end"
          placeholder="2030-12-31T23:59Z"
          type="datetime-local"
        />
        <p class="valid-feedback">In your local time; sent as UTC.</p>
      </div>
    </div>
  </div>
</ng-container>

